import { UserDepartment } from "./user-department";

export interface UserRole {
  roleId: string;
  friendlyId: string;
  departments: UserDepartment[];
  accessTags?: TagsArray[];
}

export enum UserRoleFriendlyId {
  cartRoom = "cart-room",
  acesoTv = "aceso-tv"
}

export interface TagsArray {
  tags: string[];
}
